"use client"

import { useSyncExternalStore } from "react"
import { formatAbsoluteDate } from "@/util/date"

interface RelativeTimeProps {
  date: string
  formatRelative: (date: string) => string
}

// Module scope so React does not resubscribe on every render.
const noopSubscribe = (): (() => void) => () => {}

export function RelativeTime({ date, formatRelative }: RelativeTimeProps) {
  // The server snapshot is used for SSR and hydration only, so cached HTML and
  // the first client render agree. A fresh client mount (client-side navigation)
  // reads the client snapshot and paints the relative string immediately.
  const mounted = useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  )

  if (Number.isNaN(new Date(date).getTime())) {
    return null
  }

  if (!mounted) {
    return <time dateTime={date}>{formatAbsoluteDate(date)}</time>
  }

  return <time dateTime={date}>{formatRelative(date)}</time>
}
